import { RouteProps } from 'react-router-dom';
import { authPages } from '../config/pages.config';
import DefaultAsideTemplate from '../templates/layouts/Asides/DefaultAside.template';

const asideRoutes: RouteProps[] = [
	...Object.keys(authPages).map((key) => {
		return {
			path: authPages[key as keyof typeof authPages].to,
			element: null,
		};
	}),
	{ path: '/', element: null },
	{ path: '/app', element: null },
	{ path: '/patients', element: null },
	{ path: '/patients/*', element: null },
	{ path: '/patients/*/notes/*', element: null },
	{ path: '/profile', element: null },
	{ path: '*', element: <DefaultAsideTemplate /> },
];

export default asideRoutes;
